import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Box, { dimensions, spacing, position, layout } from 'ui-box';
import FormFieldLabel from './FormFieldLabel';
import FormFieldDescription from './FormFieldDescription';
import FormFieldValidationMessage from './FormFieldValidationMessage';
import FormFieldHint from './FormFieldHint';

var FormField =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FormField, _PureComponent);

  function FormField() {
    _classCallCheck(this, FormField);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormField).apply(this, arguments));
  }

  _createClass(FormField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hint = _this$props.hint,
          label = _this$props.label,
          labelFor = _this$props.labelFor,
          children = _this$props.children,
          isRequired = _this$props.isRequired,
          labelProps = _this$props.labelProps,
          description = _this$props.description,
          validationMessage = _this$props.validationMessage,
          props = _objectWithoutProperties(_this$props, ["hint", "label", "labelFor", "children", "isRequired", "labelProps", "description", "validationMessage"]);

      return React.createElement(Box, props, React.createElement(FormFieldLabel, _extends({
        htmlFor: labelFor,
        isAstrixShown: isRequired,
        marginBottom: description ? 0 : 4
      }, labelProps), label), typeof description === 'string' ? React.createElement(FormFieldDescription, {
        marginBottom: 4
      }, description) : description, children, typeof validationMessage === 'string' ? React.createElement(FormFieldValidationMessage, {
        marginTop: 8
      }, validationMessage) : validationMessage, typeof hint === 'string' ? React.createElement(FormFieldHint, {
        marginTop: 6
      }, hint) : hint);
    }
  }]);

  return FormField;
}(PureComponent);

FormField.displayName = "FormField";

_defineProperty(FormField, "propTypes", _objectSpread({
  /**
   * The label used above the input element.
   */
  label: PropTypes.node.isRequired,

  /**
   * Passed on the label as a htmlFor prop.
   */
  labelFor: PropTypes.string,

  /**
   * Wether or not show a asterix after the label.
   */
  isRequired: PropTypes.bool,

  /**
   * A optional description of the field under the label, above the input element.
   */
  description: PropTypes.node,

  /**
   * A optional hint under the input element.
   */
  hint: PropTypes.node,

  /**
   * If a validation message is passed it is shown under the input element
   * and above the hint. This is unaffected by `isInvalid`.
   */
  validationMessage: PropTypes.node
}, dimensions.propTypes, spacing.propTypes, position.propTypes, layout.propTypes));

_defineProperty(FormField, "defaultProps", {
  labelProps: {
    size: 400
  }
});

export { FormField as default };